function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { searchWithdrawal, getWithdrawalStats, applyWithdrawal } from '@/api/supplier/withdrawal';
export default {
  name: 'SupplierWithdrawal',
  data: function data() {
    return {
      loading: false,
      applyLoading: false,
      list: [],
      total: 0,
      search: {
        status: null,
        billNo: ''
      },
      page: 1,
      limit: 20,
      stats: {
        availableAmount: '0.00',
        withdrawnAmount: '0.00',
        settledAmount: '0.00'
      },
      applyVisible: false,
      applyForm: {
        amount: '',
        withdrawType: 0,
        bankName: '',
        accountName: '',
        accountNumber: '',
        bankBranch: '',
        unionBankCode: '',
        mark: ''
      },
      applyRules: {
        amount: [{
          required: true,
          message: '请输入提现金额',
          trigger: 'blur'
        }],
        withdrawType: [{
          required: true,
          message: '请选择提现类型',
          trigger: 'change'
        }],
        bankName: [{
          required: true,
          message: '请输入开户银行',
          trigger: 'blur'
        }],
        accountName: [{
          required: true,
          message: '请输入账户名称',
          trigger: 'blur'
        }],
        accountNumber: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.handleSearch();
            case 1:
              this.loadStats();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    loadStats: function () {
      var _loadStats = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getWithdrawalStats();
            case 1:
              data = _context2.v;
              this.stats = data || {};
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadStats() {
        return _loadStats.apply(this, arguments);
      }
      return loadStats;
    }(),
    handleReset: function handleReset() {
      this.search = {
        status: null,
        billNo: ''
      };
      this.page = 1;
      this.handleSearch();
    },
    handleSearch: function () {
      var _handleSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              _context3.p = 1;
              _context3.n = 2;
              return searchWithdrawal(_objectSpread(_objectSpread({}, this.search), {}, {
                page: this.page,
                limit: this.limit
              }));
            case 2:
              data = _context3.v;
              this.list = data.list || [];
              this.total = data.total || 0;
            case 3:
              _context3.p = 3;
              this.loading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function handleSearch() {
        return _handleSearch.apply(this, arguments);
      }
      return handleSearch;
    }(),
    openApplyDialog: function openApplyDialog() {
      this.applyForm = {
        amount: '',
        withdrawType: 0,
        bankName: '',
        accountName: '',
        accountNumber: '',
        bankBranch: '',
        unionBankCode: '',
        mark: ''
      };
      this.applyVisible = true;
    },
    handleApply: function () {
      var _handleApply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t2, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return this.$refs.applyForm.validate();
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              return _context4.a(2);
            case 3:
              this.applyLoading = true;
              _context4.p = 4;
              _context4.n = 5;
              return applyWithdrawal(this.applyForm);
            case 5:
              this.$message.success('提现申请已提交');
              this.applyVisible = false;
              this.handleSearch();
              this.loadStats();
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t3 = _context4.v;
              this.$message.error('提交失败');
            case 7:
              _context4.p = 7;
              this.applyLoading = false;
              return _context4.f(7);
            case 8:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 6, 7, 8], [0, 2]]);
      }));
      function handleApply() {
        return _handleApply.apply(this, arguments);
      }
      return handleApply;
    }(),
    wdStatusType: function wdStatusType(s) {
      if (s === 0) return 'warning';
      if (s === 1) return 'success';
      if (s === 2) return '';
      if (s === 3) return '';
      if (s === 4) return 'danger';
      if (s === -1) return 'danger';
      return 'info';
    },
    wdStatusText: function wdStatusText(s) {
      if (s === 0) return '审核中';
      if (s === 1) return '待打款';
      if (s === 2) return '已打款';
      if (s === 3) return '受理中';
      if (s === 4) return '提现失败';
      if (s === -1) return '已驳回';
      return s + '';
    }
  }
};